gsap.registerPlugin();

function initFlickCards() {
    const sliders = document.querySelectorAll('[data-flick-cards-init]');

    sliders.forEach(slider => {
        const list = slider.querySelector('[data-flick-cards-list]');
        if (!list) return;

        const cards = Array.from(list.querySelectorAll('[data-flick-cards-item]'));
        const prevBtn = slider.querySelector('[data-flick-prev]');
        const nextBtn = slider.querySelector('[data-flick-next]');
        const total = cards.length;

        if (total < 2) return;

        let activeIndex = 0;
        let isAnimating = false;
        /** User-chosen mute state shared across all clips in this carousel (starts muted for autoplay). */
        let preferredMuted = true;
        let videoPlayGeneration = 0;

        cards.forEach(card => {
            card.style.willChange = 'transform, opacity';
        });

        slider.addEventListener('uivideo-mute-preference', (e) => {
            const t = e.target;
            if (!(t instanceof HTMLElement) || !slider.contains(t)) return;
            preferredMuted = Boolean(e.detail?.muted);
            cards.forEach((card) => {
                const uiVideo = card.querySelector('ui-video');
                const video = card.querySelector('video');
                if (!uiVideo || !video) return;
                video.muted = preferredMuted;
                uiVideo.updateMuteUI?.();
            });
        });

        // ONLY change: default pushes out instead of snapping to x:0
        function getConfig(i, currentIndex) {
            let diff = i - currentIndex;
            if (diff > total / 2) diff -= total;
            else if (diff < -total / 2) diff += total;

            switch (diff) {
                case 0: return { x: 0, s: 1, z: 5, darkness: 0, visible: true };
                case 1: return { x: 30, s: 0.9, z: 4, darkness: 0.5, visible: true };
                case -1: return { x: -30, s: 0.9, z: 4, darkness: 0.5, visible: true };
                case 2: return { x: 55, s: 0.80, z: 3, darkness: 0.8, visible: true };
                case -2: return { x: -55, s: 0.80, z: 3, darkness: 0.8, visible: true };
                default:
                    const dir = diff > 0 ? 1 : -1;
                    return {
                        x: 80 * dir,
                        s: 0.6,
                        z: 1,
                        darkness: 0.8,
                        visible: false
                    };
            }
        }

        function getWrappedIndex(i) {
            return (i + total) % total;
        }

        function ensureVideoLoaded(uiVideo, video, preload = 'metadata') {
            if (!uiVideo || !video) return;
            const src = uiVideo.dataset.src;
            if (!src) return;

            const currentSrc = video.getAttribute('src');
            if (!currentSrc) {
                video.src = src;
                video.playsInline = true;
                video.preload = preload;
                // Start fetching immediately so next/prev swipe starts faster.
                video.load();
                return;
            }

            video.preload = preload;
        }

        function updateVideos(index, playGeneration) {
            const prevIndex = getWrappedIndex(index - 1);
            const nextIndex = getWrappedIndex(index + 1);

            cards.forEach((card, i) => {
                const uiVideo = card.querySelector('ui-video');
                const video = card.querySelector('video');
                if (!uiVideo || !video) return;

                video.muted = preferredMuted;
                uiVideo.updateMuteUI?.();

                if (i === index) {
                    ensureVideoLoaded(uiVideo, video, 'metadata');

                    const tryPlayWithFallback = () => {
                        if (playGeneration !== videoPlayGeneration) return;
                        // On mobile, unmuted programmatic play is often blocked after swipe.
                        uiVideo.play().catch(() => {
                            if (playGeneration !== videoPlayGeneration) return;
                            video.muted = true;
                            uiVideo.updateMuteUI?.();
                            return uiVideo.play().catch(() => { });
                        });
                    };

                    if (video.readyState >= 2) {
                        tryPlayWithFallback();
                    } else {
                        const onCanPlay = () => {
                            if (playGeneration !== videoPlayGeneration) return;
                            tryPlayWithFallback();
                        };
                        video.addEventListener('canplay', onCanPlay, { once: true });
                    }
                } else if (i === prevIndex || i === nextIndex) {
                    // Preload adjacent cards so swiping feels instant.
                    ensureVideoLoaded(uiVideo, video, 'auto');
                    uiVideo.pause();
                    video.currentTime = 0;
                } else {
                    uiVideo.pause();
                    video.currentTime = 0;
                }
            });
        }

        function renderCards(index) {
            isAnimating = true;

            cards.forEach((card, i) => {
                const cfg = getConfig(i, index);
                const overlay = card.querySelector('[data-flick-overlay]');

                card.style.zIndex = cfg.z;

                if (!cfg.visible) {
                    gsap.to(card, {
                        duration: 1,
                        ease: 'elastic.out(1.2, 1)',
                        xPercent: cfg.x,
                        scale: cfg.s,
                        autoAlpha: 0
                    });
                } else {
                    gsap.to(card, {
                        duration: 1,
                        ease: 'elastic.out(1.2, 1)',
                        xPercent: cfg.x,
                        scale: cfg.s,
                        autoAlpha: 1
                    });
                }

                if (overlay) {
                    gsap.killTweensOf(overlay);
                    gsap.to(overlay, {
                        duration: 1,
                        ease: 'power3.out',
                        opacity: cfg.darkness
                    });
                }
            });

            videoPlayGeneration += 1;
            const playGeneration = videoPlayGeneration;
            updateVideos(index, playGeneration);

            gsap.delayedCall(0.6, () => {
                isAnimating = false;
            });
        }

        function next() {
            if (isAnimating) return;
            activeIndex = (activeIndex + 1) % total;
            renderCards(activeIndex);
        }

        function prev() {
            if (isAnimating) return;
            activeIndex = (activeIndex - 1 + total) % total;
            renderCards(activeIndex);
        }

        nextBtn?.addEventListener('click', next);
        prevBtn?.addEventListener('click', prev);

        let startX = 0;
        let startY = 0;
        let isSwiping = false;

        slider.addEventListener('touchstart', e => {
            if (isAnimating) return;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            isSwiping = true;
        }, { passive: true });

        slider.addEventListener('touchend', e => {
            if (!isSwiping || isAnimating) return;

            const endX = e.changedTouches[0].clientX;
            const endY = e.changedTouches[0].clientY;

            const diffX = endX - startX;
            const diffY = endY - startY;

            if (Math.abs(diffX) < 40 || Math.abs(diffX) < Math.abs(diffY)) {
                isSwiping = false;
                return;
            }

            if (diffX < 0) next();
            else prev();

            isSwiping = false;
        }, { passive: true });

        renderCards(activeIndex);
    });
}

document.addEventListener('DOMContentLoaded', initFlickCards);